import { render, staticRenderFns } from "./AnswerSuggestions.vue?vue&type=template&id=7bd34fba"
import script from "./AnswerSuggestions.vue?vue&type=script&lang=js"
export * from "./AnswerSuggestions.vue?vue&type=script&lang=js"
import style0 from "./AnswerSuggestions.vue?vue&type=style&index=0&id=7bd34fba&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports